import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ProductCard.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
